import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import { modernizer } from './modernizr';

import App from './App';
import { initSegment } from './analytics';
import ReactModal from 'react-modal';
import { applyDynamicFontSize } from './fontsize';
import { applyBottomSpacer } from './bottomSpacer';

// Overwrite intl so prices work correctly
if (typeof document === 'undefined') {
  global.Intl = require('intl');
}

// Export your top level component as JSX (for static rendering)
export default App;

// Render your app
if (typeof document !== 'undefined') {
  const renderMethod = ReactDOM.hydrate || ReactDOM.render;

  // fixes paths for client-side hydration when route is a/b tested
  if (window.__routeInfo) {
    if (window.__routeInfo.path !== '404') {
      window.__routeInfo.path = window.__routeInfo.allProps.path;
    }
  }

  const render = Comp => {
    renderMethod(<Comp />, document.getElementById('root'));
  };
  // Render!
  applyDynamicFontSize();
  applyBottomSpacer();
  render(App);
  modernizer(window, document);
  ReactModal.setAppElement(document.getElementById('root'));
  initSegment();
}



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/index.js